<template>
    <div class="pb-5 center side-padding">

      <!-- <Loading :active.sync="loading" ></Loading> -->
      <DatePicker
        v-if="!loading"
        is-range
        locale="cs"
        :attributes="attributes"
        v-model="range"
        is-inline
        :rows="2"
        :columns="$screens({ default: 1, lg: 3})"
      ></DatePicker>

      <input type="hidden" v-model="formattedStart" name="from">
      <input type="hidden" v-model="formattedEnd" name="to">

    </div>
</template>

<script>
import axios from "axios";

// import 'vue-loading-overlay/dist/vue-loading.css'
import { DatePicker } from 'v-calendar';

export default {
  components: {
    DatePicker,
    // Loading: () => import('vue-loading-overlay'),
  },

  props: [ 'from', 'to'],

  data() {
    return {
      allOb: [],
      allRez: [],
      ob_ob_days: [],
      rez_rez_days: [],
      ob_rez_days: [],
      rez_ob_days: [],
      attributes: [],
      popoverData: {
        label: "Střídání hostů",
        hideIndicator: true
      },
      range: {
        start: null,
        end: null
      },
      loading: true,
    };
  },

  computed: {
      formattedStart() {
          return this.covertToPragueTimeZoneFormattedDate(this.range.start || this.from);
      },
      formattedEnd() {
          return this.covertToPragueTimeZoneFormattedDate(this.range.end || this.to);
      }
  },

  methods: {

    pad(number) {
      if (number < 10) {
        return '0' + number;
      }
      return number;
    },

    covertToPragueTimeZoneFormattedDate(date) {
      let d = new Date(date).toLocaleDateString('en-US', { timeZone: 'Europe/Prague' });
      let pragueTimeZoneDate = new Date(d);

      return pragueTimeZoneDate.getFullYear() + 
        '-' + (this.pad(pragueTimeZoneDate.getMonth() + 1)) +
        '-' + (this.pad(pragueTimeZoneDate.getDate()));
    },

    processReservations(reservations) {
      reservations.forEach((r, index, arr) => {
        let res = {
          start: new Date(r.start),
          end: new Date(r.end)
        };

        if (index === 0) {
          if (r.type === "ob") {
            this.allOb.push(res);
          } else {
            this.allRez.push(res);
          }
        } else {
          let prev = arr[index - 1];
          if (prev.end === r.start) {
            if (prev.type === "ob" && r.type === "ob") {
              this.ob_ob_days.push(res.start);
            } else if (prev.type === "ob" && r.type === "rez") {
              this.ob_rez_days.push(res.start);
            } else if (prev.type === "rez" && r.type === "ob") {
              this.rez_ob_days.push(res.start);
            } else if (prev.type === "rez" && r.type === "rez") {
              this.rez_rez_days.push(res.start);
            }

            if (r.type === "ob") {
              let index = this.allOb
                .map(r => r.end.getTime())
                .indexOf(res.start.getTime());
              if (index !== -1) {
                this.allOb[index].end = res.end;
              } else {
                this.allOb.push(res);
              }
            } else {
              let index = this.allRez
                .map(r => r.end.getTime())
                .indexOf(res.start.getTime());
              if (index !== -1) {
                this.allRez[index].end = res.end;
              } else {
                this.allRez.push(res);
              }
            }
          } else {
            if (r.type === "ob") {
              this.allOb.push(res);
            } else {
              this.allRez.push(res);
            }
          }
        }
      });
    }
  },

  mounted() {
    axios
      .get("/reservations")
      .then(res => {
        this.processReservations(res.data.data);

        this.attributes = [
          {
            key: 'today',
            dot: true,
            dates: new Date(),
          },
          {
            key: "obsazeno",
            highlight: {
              color: "red",
              fillMode: "light"
            },
            dates: this.allOb
          },
          {
            key: "rezervace",
            highlight: {
              fillMode: "light"
            },

            dates: this.allRez
          },
          {
            key: "stridani_ob_ob",
            highlight: {
              class: "stridani_ob_ob",
              contentClass: "stridani_ob_ob_color"
            },
            dates: this.ob_ob_days,
            popover: this.popoverData
          },
          {
            key: "stridani_rez_rez",
            highlight: {
              class: "stridani_rez_rez",
              contentClass: "stridani_rez_rez_color"
            },
            dates: this.rez_rez_days,
            popover: this.popoverData
          },
          {
            key: "stridani_rez_ob",
            highlight: {
              class: "stridani_rez_ob",
              contentClass: "stridani_rez_ob_color"
            },
            dates: this.rez_ob_days,
            popover: this.popoverData
          },
          {
            key: "stridani_ob_rez",
            highlight: {
              class: "stridani_ob_rez",
              contentClass: "stridani_ob_rez_color"
            },
            dates: this.ob_rez_days,
            popover: this.popoverData
          }
        ];
        this.loading = false;
      })
      .catch(err => {
        console.error("Fetching reservations failed", err);
      });
  }
};
</script>

<style>
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.side-padding {
  padding-left: 48px;
  padding-right: 48px;
}

.pb-5 {
  padding-bottom: 32px;
}

.stridani_ob_ob {
  background-image: url("https://chata-luhacovice.cz/calendar-assets/stridani_ob_ob.svg");
}

.stridani_ob_ob_color {
  color: #742A2A;
}

.stridani_rez_rez {
  background-image: url("https://chata-luhacovice.cz/calendar-assets/stridani_rez_rez.svg");
}

.stridani_rez_rez_color {
  color: #001735;
}

.stridani_rez_ob {
  background-image: url("https://chata-luhacovice.cz/calendar-assets/stridani_rez_ob.svg");
}

.stridani_rez_ob_color {
  color: #222222;
}

.stridani_ob_rez {
  background-image: url("https://chata-luhacovice.cz/calendar-assets/stridani_ob_rez.svg");
}

.stridani_ob_rez_color {
  color: #252525;
}

.rounded-color {
  height: 25px;
  width: 25px;

  border-radius: 50%;
  display: inline-block;
}

.bg-blue {
  background-color: #bee3f8;
}

.bg-red {
  background-color: #fed7d7;
}

.img-text-container {
  display: flex;
  justify-content: center;
}
</style>